<template>
  <v-card class="sidebar-featured pb-4" v-if="showProvider" color="grey darken-2">
    <v-card-title class="subheading sidebar-featured__heading">Add this account?</v-card-title>
    <v-list light class="py-0">
      <li>
        <add-provider-link
          :provider="provider"
          :title="linkTitle"
          class="v-list__tile v-list__tile--link v-list__tile--avatar"
        >
          <div class="v-list__tile__avatar" v-if="logo">
            <avatar-logo
              :src="logo"
              :alt="provider.name"
            />
          </div>
          <v-list-tile-avatar v-else>
            <v-icon class="grey lighten-1 white--text">domain</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ provider.name }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon color="primary">add_circle</v-icon>
          </v-list-tile-action>
        </add-provider-link>
      </li>
    </v-list>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex'
  import { logoFor, foldersFor } from '@/helpers/providers'
  import AddProviderLink from '@/components/common/AddProviderLink'
  import AvatarLogo from '@/components/common/AvatarLogo'

  export default {
    computed: {
      ...mapState('providers', ['provider']),
      logo () {
        return logoFor(this.provider, {size: 'small'})
      },
      showProvider () {
        return this.provider && !foldersFor(this.provider).length
      },
      linkTitle () {
        return `Add ${this.provider.name} to your Bills &amp; Accounts List`
      }
    },
    components: {
      AddProviderLink,
      AvatarLogo
    }
  }
</script>



// WEBPACK FOOTER //
// frontend/src/components/list/FeaturedProvider.vue